export enum TipsPricingEffect {
    // Percentage of payment amount to add
    PERCENTAGE = "percentage",
    // Money to add
    FIXED_PRICE = "fixed_price"
}